import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import $ from 'jquery';
extend("required", {
    ...required,
    message: "Ce champ est obligatoire !",
});


export default {
    name: 'creer-patient-modal',
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    // identite_initiale : { nom, prenoms, telephone } d'une demande de rendez-vous faite en ligne (04/10/2026).
    props: ["type_enreg", "identite_initiale"],
    data() {
        return {
            type_patient: "non_assure",
            // assur_validite: '',
            // assur_taux_couverture: '',

            assur_selected: "",
            societe_selected: "",
            liste_societes: [],

            // Société à convention directe : travailleur ou membre de sa famille retrouvé à l'accueil (04/10/2026).
            membre_recherche: '',
            membres_trouves: [],
            membre_choisi: null,
            // Introuvable dans la liste : ajouté à la convention à l'enregistrement (04/10/2026).
            ajouter_membre: true,
            nouveau_travailleur: null,
            // Assurance, convention ou société absente : créée depuis l'accueil (04/10/2026).
            creation: null,
            creation_societe: null,
            societe_a_choisir: null,
            recherche_membre_en_cours: false,
            recherche_membre_minuteur: null,

            loading: false,
            btn_disable: false,
            // nomPatient: "",
            // prenomsPatient: "",
            // agePatient: "",
            // telPatient: "",
            assureur: null,
            ticket: null,
            // sexe: "",
            sexes: [],
            picked_type_client: "",
            picked_choice: "oui",
            age_unit: 'ans',
            second_phone_visible: false,
            malade_country_iso: this.default_country_code || '',
            second_country_code: '',

            new_patient: {
                country_suffix: this.default_country_code,
                le_malade: "",
                l_accompagnant: "",
                la_personne_a_prevenir: "",
                type_patient: "non_assure",
                assur_selected: "",
                societe_selected: "",
                assur_validite: "",
                assur_taux_couverture: "",
                assur_principal_matricule: "",
                assur_principal_nom: "",
                assur_principal_prenom: "",
                assur_principal_sexe: "",
                assur_principal_phone: "",
                malade_matricule: "",
                malade_nom: "",
                malade_prenom: "",
                malade_sexe: "",
                malade_age: "",
                malade_phone: "",
                malade_phone_secondaire: "",
                malade_quartier: "",
                malade_profession: "",
                accompagnant_nom: "",
                accompagnant_prenom: "",
                accompagnant_phone: "",
                accompagnant_filiation: "",
                accompagnant_quartier: "",
                accompagnant_profession: "",
                personne_a_prevenir_nom: "",
                personne_a_prevenir_prenom: "",
                personne_a_prevenir_phone: "",
                personne_a_prevenir_filiation: "",
                personne_a_prevenir_quartier: "",
                personne_a_prevenir_profession: "",
            },


            // Tel input placeholder config
            options: { placeholder: "Ex. 90 00 00 00", maxlength: 11 },
            tel_is_required: false,
            country_code: "",
            malade_country_code: "",
            accompagnant_country_code: "",
            personne_a_prevenir_country_code: "",

            prefered_countries: [this.default_country_code],
            only_countries: ["tg", "bj", "ci", "bf"],

            url_to_go: "",

            is_child_consult: false,
        };
    },

    watch: {
        picked_choice() {
            this.new_patient.malade_age = ''
        },
        assur_selected() {
            this.societe_selected = ''
            this.oublierMembre()
            this.choixAssurance()
        },

        societe_selected() {
            this.new_patient.assur_validite = ''
            this.new_patient.assur_taux_couverture = ''

            console.log(">> ", this.societe_selected)

            if (this.souscripteurs.length > 0) {
                this.choixSociete()
            }

        }
    },

    computed: {
        estConvention() {
            return !!this.assur_selected && this.assur_selected.type_tiers === 'convention'
        },
        // Établissement en Congo-Kinshasa (pays de l'établissement) : « Abonné » au lieu d'« Assuré » (04/10/2026).
        estEtablissementRdc() {
            return String(this.default_country_code || '').toLowerCase() === 'cd'
        },
        libelleAssure() {
            return this.estEtablissementRdc ? 'Abonné' : 'Assuré'
        },
        libelleNonAssure() {
            return this.estEtablissementRdc ? 'Non abonné' : 'Non assuré'
        },
        libelleNomPatient() {
            return String(this.malade_country_iso || this.default_country_code || '').toLowerCase() === 'cd' ? 'Nom & Postnom' : 'Nom'
        },
        assurances() {
            return this.$store.getters["assurances"];
        },

        souscripteurs() {
            return this.$store.getters["souscripteurs"];
        },

        patient_created() {
            return this.$store.getters["patient"];
        },

        cons_selected() {
            return this.$store.getters["typeConsSelected"]
        },

        liste_filiation() {
            return this.$store.getters["liste_filiation"];
        },

        patient() {
            return this.$store.getters["patient"];
        },
    },
    mounted() {
        this.new_patient.country_suffix = this.default_country_code
        const identite = this.identite_initiale
        if (identite) {
            this.new_patient.malade_nom = identite.nom || ''
            this.new_patient.malade_prenom = identite.prenoms || ''
            this.new_patient.malade_phone = this.numeroSansIndicatif(identite.telephone)
        }
        setTimeout(() => {
            $('.shw').fadeIn()
        }, 500);

        if (
            this.cons_selected.consult_name == 'Consultation Pédiatrique' || this.cons_selected.consult_name == 'Pédiatrie' ||
            this.cons_selected.consult_name == 'Consultation Néonatologique' ||
            this.cons_selected.consult_name == 'Consultation d\'allergologie'
        ) {
            this.is_child_consult = true
        }

        this.$store.dispatch('getListeFiliation', { data_type: 'filiation' })

        this.$store.dispatch("getSexes").then((response) => {
            this.sexes = response

            if (this.cons_selected.consult_abr == 'CPN' && this.type_enreg) {
                this.new_patient.malade_sexe = this.sexes.find(el => el.description == "Femme");
            }
        })

        this.$store.dispatch("getAssurances")

        // let assurance_id = 7
        // this.$store.dispatch("getSocieteByAssurance", assurance_id).then(() => {
        //     
        //     this.liste_societes = this.souscripteurs
        // })

    },
    methods: {
        normaliserIdentite(value, prenoms = false) {
            const text = String(value || '').normalize('NFC')
            return prenoms ? text.toLocaleLowerCase('fr').replace(/(^|[\s'’-])(\p{L})/gu, (_, separator, letter) => separator + letter.toLocaleUpperCase('fr')) : text.toLocaleUpperCase('fr')
        },
        saisirIdentite(field, event) {
            const input = event.target, cursor = input.selectionStart
            const value = this.normaliserIdentite(input.value, field === 'malade_prenom')
            this.new_patient[field] = value
            this.$nextTick(() => { input.value = value; if (cursor !== null) input.setSelectionRange(cursor, cursor) })
        },
        telephoneAvecIndicatif(value, prefix) {
            const telephone = String(value || '').trim()
            return !telephone || telephone.startsWith('+') ? telephone : (String(prefix || '') + ' ' + telephone).trim()
        },
        retirerSecondTelephone() {
            this.new_patient.malade_phone_secondaire = ''
            this.second_phone_visible = false
        },
        secondCountryChanged(country) {
            this.second_country_code = '+' + country.dialCode
        },
        /**
         * Choix entre Patient assuré ou non
         */
        onAssurance() {
            if (this.new_patient.type_patient == 'assure') {
                // Le patient est assuré
                $('.est-assure').fadeIn(500)
            } else {
                // Le patient n'est pas assuré
                $('.est-assure').fadeOut(500)
            }
        },

        choixAssurance() {
            let assurance_id = this.assur_selected.id

            if (assurance_id > 0) {
                this.$store.dispatch("getSocieteByAssurance", assurance_id).then(() => {
                    this.liste_societes = this.souscripteurs
                    // Société créée depuis l'accueil : choisie d'office.
                    if (this.societe_a_choisir) {
                        const creee = this.liste_societes.find(s => Number(s.id) === Number(this.societe_a_choisir))
                        this.societe_a_choisir = null
                        if (creee) {
                            this.societe_selected = creee
                            return
                        }
                    }
                    // Une convention n'a qu'un contrat : il est choisi d'office.
                    if (this.estConvention && this.liste_societes.length === 1) this.societe_selected = this.liste_societes[0]
                })
            } else {
                this.liste_societes = []
            }
        },

        choixSociete() {
            if (this.societe_selected.souscripteur != undefined) {
                this.new_patient.assur_validite = this.societe_selected.duree_restante
                this.new_patient.assur_taux_couverture = this.societe_selected.taux_consultation + '%'
                this.appliquerTauxMembre()
            }
        },

        // Recherche du travailleur (matricule, nom, prénom) ; sa famille vient avec lui.
        rechercherMembre() {
            this.membre_choisi = null
            clearTimeout(this.recherche_membre_minuteur)
            const q = String(this.membre_recherche || '').trim()
            if (q.length < 2 || !this.estConvention) {
                this.membres_trouves = []
                return
            }
            this.recherche_membre_minuteur = setTimeout(() => this.chercherMembres(q), 300)
        },

        chercherMembres(q) {
            this.recherche_membre_en_cours = true
            return this.$store.dispatch('rechercherMembresConvention', { assurance_id: this.assur_selected.id, q }).then(reponse => {
                if (String(this.membre_recherche || '').trim() !== q) return
                this.membres_trouves = reponse && Array.isArray(reponse.membres) ? reponse.membres : []
            }).catch(() => {
                this.membres_trouves = []
            }).then(() => {
                this.recherche_membre_en_cours = false
            })
        },

        // Le membre choisi remplit l'assuré principal (son travailleur) et le malade.
        choisirMembre(membre) {
            if (!membre.couvert || membre.patient_id) return
            this.membre_choisi = membre
            this.membres_trouves = []
            this.membre_recherche = (membre.nom + ' ' + (membre.prenoms || '')).trim()
            // Assuré principal = le travailleur, avec toute son identité.
            this.new_patient.assur_principal_matricule = membre.matricule_travailleur || membre.matricule || ''
            this.new_patient.assur_principal_nom = membre.travailleur_nom || ''
            this.new_patient.assur_principal_prenom = membre.travailleur_prenoms || ''
            this.new_patient.assur_principal_sexe = this.sexeParId(membre.travailleur_sexe_id)
            this.new_patient.assur_principal_phone = this.numeroSansIndicatif(membre.travailleur_telephone)
            this.new_patient.assur_principal_profession = membre.travailleur_profession || ''
            this.new_patient.assur_principal_quartier = membre.travailleur_quartier || ''
            const malade = { travailleur: '1', conjoint: '2', enfant: '3' }[membre.lien] || '4'
            this.new_patient.le_malade = malade
            this.onMalade(malade === '4' ? 0 : Number(malade))
            if (malade !== '1') {
                // Le malade garde son propre matricule (celui du travailleur s'il n'en a pas) et sa propre identité.
                this.new_patient.malade_matricule = membre.matricule || ''
                this.new_patient.malade_nom = membre.nom || ''
                this.new_patient.malade_prenom = membre.prenoms || ''
                if (membre.sexe_id) this.new_patient.malade_sexe = this.sexeParId(membre.sexe_id)
                this.new_patient.malade_phone = this.numeroSansIndicatif(membre.telephone)
                this.new_patient.malade_quartier = membre.quartier || membre.travailleur_quartier || ''
                this.new_patient.malade_profession = membre.profession || ''
            }
            this.remplirDateNaissance(membre.date_naissance)
            this.appliquerTauxMembre()
        },

        sexeParId(id) {
            return (this.sexes || []).find(sexe => Number(sexe.id) === Number(id)) || ''
        },

        // Numéro enregistré « +indicatif numéro » : le champ téléphone garde le drapeau de l'établissement.
        numeroSansIndicatif(telephone) {
            const texte = String(telephone || '').trim()
            const morceaux = /^\+\d{1,4}\s+(.+)$/.exec(texte)
            return morceaux ? morceaux[1] : texte
        },

        // Date de naissance connue : « Oui » puis la date (le changement de choix vide le champ, d'où le nextTick).
        remplirDateNaissance(date) {
            if (!date) return
            if (this.picked_choice === 'oui') {
                this.new_patient.malade_age = date
                return
            }
            this.picked_choice = 'oui'
            this.$nextTick(() => { this.new_patient.malade_age = date })
        },

        appliquerTauxMembre() {
            const membre = this.membre_choisi
            if (membre && membre.taux_effectif !== null && membre.taux_effectif !== undefined) {
                this.new_patient.assur_taux_couverture = membre.taux_effectif + '%'
            }
        },

        oublierMembre() {
            this.nouveau_travailleur = null
            clearTimeout(this.recherche_membre_minuteur)
            this.membre_choisi = null
            this.membres_trouves = []
            this.membre_recherche = ''
        },

        // Travailleur absent : formulaire pré-rempli depuis la recherche (premier mot = nom, le reste = prénoms).
        ouvrirNouveauTravailleur() {
            const mots = String(this.membre_recherche || '').trim().split(/\s+/).filter(Boolean)
            const nom = mots.length ? mots[0].toUpperCase() : '', prenoms = mots.slice(1).join(' ')
            this.nouveau_travailleur = { matricule: '', nom, prenoms, sexe_id: null, date_naissance: '', telephone: '', indicatif: '',
                profession: '', quartier: '', erreur: '', en_cours: false,
                // Patient = un membre de la famille (04/10/2026) : travailleur à créer ou déjà connu.
                pour_famille: false, travailleur_existant: null, famille: this.familleVide(), depuis_recherche: { nom, prenoms } }
        },

        familleVide() {
            // nom_propose : nom du travailleur repris d'office pour un enfant, tant qu'il n'est pas modifié.
            return { lien: 'enfant', filiation: '', matricule: '', nom: '', prenoms: '', sexe_id: null, date_naissance: '', telephone: '', indicatif: '', profession: '', quartier: '', nom_propose: '' }
        },

        // Parent ou autre : la filiation précise de qui il s'agit (05/10/2026).
        lienAvecFiliation(lien) {
            return lien === 'parent' || lien === 'autre'
        },

        filiationsProposees(lien) {
            return lien === 'parent' ? ['Père', 'Mère']
                : ['Tante', 'Oncle', 'Cousin', 'Cousine', 'Neveu', 'Nièce', 'Frère', 'Sœur', 'Grand-père', 'Grand-mère', 'Beau-père', 'Belle-mère']
        },

        // Travailleur déjà enregistré (même déjà patient) : seul le membre de sa famille est ajouté.
        ouvrirFamilleDe(travailleur) {
            this.ouvrirNouveauTravailleur()
            Object.assign(this.nouveau_travailleur, { nom: '', prenoms: '', pour_famille: true, travailleur_existant: travailleur })
            this.synchroniserNomEnfant()
        },

        // Le nom tapé dans la recherche est celui du patient : il suit le patient d'un bloc à l'autre tant qu'il n'est pas modifié.
        choisirPatientFamille(oui) {
            const t = this.nouveau_travailleur
            if (!t || t.pour_famille === oui) return
            t.pour_famille = oui
            const [de, vers] = oui ? [t, t.famille] : [t.famille, t]
            if (!vers.nom && de.nom === t.depuis_recherche.nom && de.prenoms === t.depuis_recherche.prenoms) {
                Object.assign(vers, { nom: de.nom, prenoms: de.prenoms })
                Object.assign(de, { nom: '', prenoms: '' })
            }
            this.synchroniserNomEnfant()
        },

        // Enfant : le nom du travailleur s'affiche d'office et suit sa saisie ; une fois modifié, il n'est plus touché.
        // Autre lien (conjoint, autre) : le nom proposé est retiré.
        synchroniserNomEnfant() {
            const t = this.nouveau_travailleur
            if (!t || !t.pour_famille) return
            const f = t.famille
            const automatique = !f.nom || f.nom === f.nom_propose
            if (!automatique) return
            const nom = f.lien === 'enfant' ? String((t.travailleur_existant ? t.travailleur_existant.nom : t.nom) || '') : ''
            f.nom = nom
            f.nom_propose = nom
        },

        libelleAjoutMembre(t) {
            if (!t.pour_famille) return 'Ajouter le travailleur'
            return t.travailleur_existant ? 'Ajouter le membre de la famille' : 'Ajouter le travailleur et sa famille'
        },

        nomMembre(membre) {
            return ((membre && membre.nom) + ' ' + ((membre && membre.prenoms) || '')).trim()
        },

        paysNouveauTravailleur(pays) {
            if (this.nouveau_travailleur && pays && pays.dialCode) this.nouveau_travailleur.indicatif = '+' + pays.dialCode
        },

        paysNouveauFamille(pays) {
            if (this.nouveau_travailleur && pays && pays.dialCode) this.nouveau_travailleur.famille.indicatif = '+' + pays.dialCode
        },

        donneesMembre(m, user_id) {
            const numero = String(m.telephone || '').trim()
            return { matricule: m.matricule, nom: m.nom, prenoms: m.prenoms, sexe_id: m.sexe_id, date_naissance: m.date_naissance || null,
                telephone: numero ? ((numero.charAt(0) === '+' || !m.indicatif) ? numero : m.indicatif + ' ' + numero) : '',
                profession: m.profession, quartier: m.quartier, user_id }
        },

        // Ajouté tout de suite à la convention, puis choisi : le formulaire se remplit. Patient de la famille : le travailleur
        // d'abord (s'il est nouveau), puis le membre de sa famille rattaché à lui ; c'est ce membre qui est choisi.
        ajouterNouveauTravailleur() {
            const t = this.nouveau_travailleur
            if (!t.travailleur_existant && !t.nom) { t.erreur = 'Indiquez le nom du travailleur.'; return }
            if (t.pour_famille && !t.famille.nom) { t.erreur = 'Indiquez le nom du membre de la famille.'; return }
            if (t.pour_famille && this.lienAvecFiliation(t.famille.lien) && !t.famille.filiation) {
                t.erreur = 'Précisez la filiation (' + (t.famille.lien === 'parent' ? 'père ou mère' : 'tante, oncle, cousin…') + ').'
                return
            }
            t.erreur = ''
            t.en_cours = true
            const info = this.$store.getters['authInfo']
            const user_id = info && info.user ? info.user.id : 0
            const assurance_id = this.assur_selected.id
            const travailleur = t.travailleur_existant ? Promise.resolve(t.travailleur_existant)
                : this.$store.dispatch('creerMembreConvention', { assurance_id, data: this.donneesMembre(t, user_id) })
            return travailleur.then(cree => {
                if (!t.pour_famille) return cree
                // Travailleur enregistré : un nouvel essai n'ajoute plus que le membre de sa famille.
                t.travailleur_existant = cree
                const data = Object.assign(this.donneesMembre(t.famille, user_id), { travailleur_id: cree.id, lien: t.famille.lien,
                    filiation: this.lienAvecFiliation(t.famille.lien) ? t.famille.filiation : null })
                return this.$store.dispatch('creerMembreConvention', { assurance_id, data })
            }).then(membre => {
                this.nouveau_travailleur = null
                this.choisirMembre(membre)
                const convention = this.assur_selected.raison_sociale || 'la convention'
                this.doSuccessMsgTexte((t.pour_famille ? 'Membre de la famille ajouté à ' : 'Travailleur ajouté à ') + convention)
            }).catch(erreur => {
                t.erreur = this.messageCreation(erreur, t.travailleur_existant ? 'L’ajout du membre de la famille a échoué.' : 'L’ajout du travailleur a échoué.')
                t.en_cours = false
            })
        },

        ouvrirCreationAssurance() {
            this.creation_societe = null
            this.creation = { type_tiers: 'assurance', nom: '', souscripteur: '', taux: '', erreur: '', en_cours: false }
        },

        ouvrirCreationSociete() {
            this.creation = null
            this.creation_societe = { souscripteur: '', taux: '', erreur: '', en_cours: false }
        },

        tauxCreationValide(taux) {
            return /^\d+$/.test(String(taux).trim()) && Number(taux) <= 100
        },

        messageCreation(erreur, defaut) {
            const donnees = erreur && erreur.response ? erreur.response.data : null
            return (donnees && donnees.message) || defaut
        },

        // Nouvelle compagnie (avec sa société souscriptrice) ou nouvelle société à convention ; ajoutée aux Paramètres.
        creerAssurance() {
            const c = this.creation
            if (!String(c.nom).trim()) { c.erreur = 'Indiquez le nom.'; return }
            if (c.type_tiers === 'assurance' && !String(c.souscripteur).trim()) { c.erreur = 'Indiquez la société souscriptrice.'; return }
            if (!this.tauxCreationValide(c.taux)) { c.erreur = 'Taux de prise en charge : nombre entier de 0 à 100 %.'; return }
            c.erreur = ''
            c.en_cours = true
            const info = this.$store.getters['authInfo']
            const donnees = { type_tiers: c.type_tiers, nom: String(c.nom).trim(), souscripteur: String(c.souscripteur).trim(), taux: Number(c.taux),
                user_id: info && info.user ? info.user.id : 0 }
            return this.$store.dispatch('creerAssuranceRapide', donnees).then(reponse => {
                this.societe_a_choisir = reponse.souscripteur_id
                return Promise.resolve(this.$store.dispatch('getAssurances')).then(() => {
                    const liste = Array.isArray(this.assurances) ? this.assurances : []
                    const nouvelle = liste.find(a => Number(a.id) === Number(reponse.assurance.id)) || reponse.assurance
                    this.creation = null
                    this.assur_selected = nouvelle
                    this.doSuccessMsgTexte(c.type_tiers === 'convention' ? 'Société à convention ajoutée' : 'Assurance ajoutée')
                })
            }).catch(erreur => {
                c.erreur = this.messageCreation(erreur, 'La création a échoué.')
                c.en_cours = false
            })
        },

        // Nouvelle société souscriptrice de la compagnie choisie.
        creerSociete() {
            const c = this.creation_societe
            if (!String(c.souscripteur).trim()) { c.erreur = 'Indiquez le nom de la société.'; return }
            if (!this.tauxCreationValide(c.taux)) { c.erreur = 'Taux de prise en charge : nombre entier de 0 à 100 %.'; return }
            c.erreur = ''
            c.en_cours = true
            const info = this.$store.getters['authInfo']
            const data = { souscripteur: String(c.souscripteur).trim(), taux: Number(c.taux), user_id: info && info.user ? info.user.id : 0 }
            return this.$store.dispatch('creerSouscripteurRapide', { assurance_id: this.assur_selected.id, data }).then(reponse => {
                this.societe_a_choisir = reponse.souscripteur_id
                this.creation_societe = null
                this.societe_selected = ''
                this.choixAssurance()
                this.doSuccessMsgTexte('Société ajoutée')
            }).catch(erreur => {
                c.erreur = this.messageCreation(erreur, 'La création a échoué.')
                c.en_cours = false
            })
        },

        doSuccessMsgTexte(message) {
            if (this.$toasted) this.$toasted.show(message, { duration: 3000, theme: 'toasted-primary', type: 'success', position: 'top-center' })
        },

        libelleLienMembre(membre) {
            if (membre.lien === 'travailleur') return 'Travailleur'
            // « Parent (mère) », « Autre (tante) » : libellé préparé par la Clinique quand il existe.
            const lien = membre.lien_libelle || { conjoint: 'Conjoint(e)', enfant: 'Enfant', parent: 'Parent' }[membre.lien] || 'Ayant droit'
            return lien + ' de ' + (membre.travailleur || '')
        },

        /**
         * Dis si le malade est : 
         * Lui même ou son Conjoint ou encore son enfant
         */

        onMalade(val) {
            if (val == 1) {         //  Il s'agit de Lui-même
                this.new_patient.malade_matricule = this.new_patient.assur_principal_matricule
                this.new_patient.malade_nom = this.new_patient.assur_principal_nom
                this.new_patient.malade_prenom = this.new_patient.assur_principal_prenom
                this.new_patient.malade_sexe = this.new_patient.assur_principal_sexe
                this.new_patient.malade_phone = this.new_patient.assur_principal_phone
                this.new_patient.malade_quartier = this.new_patient.assur_principal_quartier
                this.new_patient.malade_profession = this.new_patient.assur_principal_profession
            }else if(val == 0){
                this.new_patient.malade_matricule = ''
                this.new_patient.malade_nom = ''
                this.new_patient.malade_prenom = ''
                this.new_patient.malade_sexe = ''
                this.new_patient.malade_phone = ''
                this.new_patient.malade_quartier = ''
                this.new_patient.malade_profession
            }
            else {
                this.new_patient.malade_matricule = ''
                this.new_patient.malade_nom = ''
                this.new_patient.malade_prenom = ''
                this.new_patient.malade_sexe = ''
                this.new_patient.malade_phone = ''
                this.new_patient.malade_quartier = ''
                this.new_patient.malade_profession
            }
        },

        onAcompoagnant(selector) {
            let est_identique = document.getElementById(selector);
            if (est_identique.checked) {
                //  Il s'agit de l'assuré principale

                this.new_patient.accompagnant_nom =this.new_patient.assur_principal_nom
                this.new_patient.accompagnant_prenom =this.new_patient.assur_principal_prenom
                this.new_patient.accompagnant_filiation = ""
                this.new_patient.accompagnant_phone =this.new_patient.assur_principal_phone
                this.new_patient.accompagnant_quartier =this.new_patient.assur_principal_quartier;
                this.new_patient.accompagnant_profession =this.new_patient.assur_principal_profession;
            } else {

                this.new_patient.accompagnant_nom = ''
                this.new_patient.accompagnant_prenom = ''
                this.new_patient.accompagnant_sexe = ''
                this.new_patient.accompagnant_phone = ''
                this.new_patient.accompagnant_filiation = ""
                this.new_patient.accompagnant_quartier = ""
                this.new_patient.accompagnant_profession = ""
            }
        },
        onPersonneAprevenir(val) {

            console.log("val: ",val);
            if (val == 0) {         

                 this.new_patient.personne_a_prevenir_nom = "";
                 this.new_patient.personne_a_prevenir_prenom = "";
                 this.new_patient.personne_a_prevenir_phone = "";
                 this.new_patient.personne_a_prevenir_filiation = "";
                 this.new_patient.personne_a_prevenir_quartier = "";
                 this.new_patient.personne_a_prevenir_profession = "";
                //  Il s'agit de l'assuré principale

                
            } else if (val == 1) {

                this.new_patient.personne_a_prevenir_nom =this.new_patient.assur_principal_nom;
                this.new_patient.personne_a_prevenir_prenom =this.new_patient.assur_principal_prenom;
                this.new_patient.personne_a_prevenir_phone =this.new_patient.assur_principal_phone;
                this.new_patient.personne_a_prevenir_quartier =this.new_patient.assur_principal_quartier;
                this.new_patient.personne_a_prevenir_profession =this.new_patient.assur_principal_profession;
              //  Il s'agit de l'accompagnant

             
            } else if (val == 2) {

                 this.new_patient.personne_a_prevenir_nom =this.new_patient.accompagnant_nom;
                 this.new_patient.personne_a_prevenir_prenom =this.new_patient.accompagnant_prenom;
                 this.new_patient.personne_a_prevenir_phone =this.new_patient.accompagnant_phone;
                 this.new_patient.personne_a_prevenir_quartier =this.new_patient.accompagnant_quartier;
                 this.new_patient.personne_a_prevenir_profession =this.new_patient.accompagnant_profession;
                 this.new_patient.personne_a_prevenir_filiation =this.new_patient.accompagnant_filiation;
             
            } else {
              this.new_patient.personne_a_prevenir_nom = "";
              this.new_patient.personne_a_prevenir_prenom = "";
              this.new_patient.personne_a_prevenir_phone = "";
              this.new_patient.personne_a_prevenir_filiation = "";
              this.new_patient.personne_a_prevenir_quartier = "";
              this.new_patient.personne_a_prevenir_profession = "";
            }
        },

        /**
         * Clear Error message
         */
        clearError() {
            this.tel_is_required = false
        },

        countryChanged(country) {
            this.country_code = '+' + country.dialCode
        },

        maladeCountryChanged(country) {
            this.malade_country_code = '+' + country.dialCode
            this.malade_country_iso = country.iso2 || this.default_country_code
        },

        accompagnantCountryChanged(country) {
            this.accompagnant_country_code = '+' + country.dialCode
        },
        personneAPrevenirCountryChanged(country) {
            this.personne_a_prevenir_country_code = "+" + country.dialCode;
        },

        choosePatient(data) {
            this.$store.dispatch('getPatient', data.id).then(() => {
                const selected_patient = {
                    id: this.patient.id,
                    nom: this.patient.nom+" "+this.patient.prenoms,
                    nom_patient: this.patient.nom+" "+this.patient.prenoms,
                    prenoms: "",
                    sexe: this.patient.sexe.specificatif,
                    telephone_mobile: this.patient.telephone_mobile,
                    age: this.patient.age,
                    num_dossier: this.patient.code
                }
                this.$store.commit("SET_CHOSEN_PATIENT", selected_patient);
            })
        },

        async savePatient() {
            const isValid = await this.$refs.add_patient.validate();

            if (!isValid) {
                return;
            }

            let n_patient = {

            }

            let date_nais = '';
            if (this.picked_choice === 'oui') {
                let today = new Date();
                date_nais = this.dateFormatToSend(this.new_patient.malade_age).date

                if (date_nais > today) {
                    this.doErrorMsg("La date de naissance doit être antérieure à la date d'aujourd'hui")
                    return;
                } else {
                    // si tout est correct
                    date_nais = this.dateFormatToSend(this.new_patient.malade_age).date_to_send;
                }
            } else { // si c'est l'âge qui est renseigné
                const age = String(this.new_patient.malade_age).trim()
                if (!/^\d+$/.test(age) || !['jours', 'mois', 'ans'].includes(this.age_unit)) {
                    this.doErrorMsg('Saisissez un âge entier positif ou nul et choisissez son unité.')
                    return
                }
                date_nais = age;
            }
            const secondTelephone = this.second_phone_visible ? this.telephoneAvecIndicatif(this.new_patient.malade_phone_secondaire, this.second_country_code) : ''
            if (secondTelephone && (!/^\+?[\d\s().-]+$/.test(secondTelephone) || secondTelephone.replace(/\D/g, '').length < 5 || secondTelephone.replace(/\D/g, '').length > 15)) {
                this.doErrorMsg('Vérifiez le deuxième numéro de téléphone (5 à 15 chiffres, indicatif compris).')
                return
            }
            let p_tel = this.telephoneAvecIndicatif(this.new_patient.malade_phone, this.malade_country_code)
            let assur_tel = (this.new_patient.assur_principal_phone != '') ? (this.country_code + ' ' + this.new_patient.assur_principal_phone) : ''
            let accompagnant_tel = (this.new_patient.accompagnant_phone != '') ? (this.accompagnant_country_code + ' ' + this.new_patient.accompagnant_phone) : ''
            let personne_a_prevenir_tel = this.new_patient.personne_a_prevenir_phone != "" ? this.personne_a_prevenir_country_code + ' ' + this.new_patient.personne_a_prevenir_phone : '';

            n_patient = {
                country_suffix: this.new_patient.country_suffix,
                le_malade: this.new_patient.le_malade,
                type_patient: this.new_patient.type_patient,
                assur_selected: this.assur_selected.id,
                societe_selected: this.societe_selected.id,
                convention_membre_id: (this.estConvention && this.membre_choisi) ? this.membre_choisi.id : null,
                convention_ajouter_membre: (this.estConvention && !this.membre_choisi && this.ajouter_membre) ? 1 : 0,
                assur_validite: this.new_patient.assur_validite,
                assur_taux_couverture: this.new_patient.assur_taux_couverture,
                assur_principal_matricule: this.new_patient.assur_principal_matricule,
                assur_principal_nom: this.new_patient.assur_principal_nom,
                assur_principal_profession: this.new_patient.assur_principal_profession,
                assur_principal_quartier: this.new_patient.assur_principal_quartier,
                assur_principal_prenom: this.new_patient.assur_principal_prenom,
                assur_principal_sexe: this.new_patient.assur_principal_sexe.id,
                assur_principal_phone: assur_tel,
                malade_matricule: this.new_patient.malade_matricule,
                nom: this.normaliserIdentite(this.new_patient.malade_nom).trim(),
                prenoms: this.normaliserIdentite(this.new_patient.malade_prenom, true).trim(),
                sexe: this.new_patient.malade_sexe.id,
                date_naissance: date_nais,
                telephone_mobile: p_tel,
                quartier: this.new_patient.malade_quartier,
                profession: this.new_patient.malade_profession,
                l_accompagnant: this.new_patient.l_accompagnant,
                accompagnant_nom: this.new_patient.accompagnant_nom,
                accompagnant_prenom: this.new_patient.accompagnant_prenom,
                accompagnant_phone: accompagnant_tel,
                accompagnant_quartier: this.new_patient.accompagnant_quartier,
                accompagnant_profession: this.new_patient.accompagnant_profession,
                accompagnant_filiation: this.new_patient.accompagnant_filiation,
                la_personne_a_prevenir: this.new_patient.la_personne_a_prevenir,
                personne_a_prevenir_nom: this.new_patient.personne_a_prevenir_nom,
                personne_a_prevenir_prenom: this.new_patient.personne_a_prevenir_prenom,
                personne_a_prevenir_phone: personne_a_prevenir_tel,
                personne_a_prevenir_filiation: this.new_patient.personne_a_prevenir_filiation,
                personne_a_prevenir_quartier: this.new_patient.personne_a_prevenir_quartier,
                personne_a_prevenir_profession: this.new_patient.personne_a_prevenir_profession,
            };

            if (this.picked_choice === 'non') n_patient.age_unit = this.age_unit
            if (secondTelephone) n_patient.telephone_secondaire = secondTelephone

            this.$store.commit("SET_PATIENT", []);

            this.loading = true

            this.$store.dispatch("createPatient", n_patient).then((response) => {
                console.log(response);
                if (response < 0) {
                    if (response == -1) {
                        this.doErrorMsg("Ce numero de téléphone a déja été pris")
                    } else if (response == -2) {
                        this.doErrorMsg("L'adresse email a déja été prise")
                    }
                } else {
                    this.$nextTick(() => {
                        let data = {
                            id: response.id,
                            nom: response.nom,
                            prenoms: response.prenoms,
                            age: response.age
                        }
                        this.$store.commit("SET_CHOSEN_PATIENT", {});

                        this.$store.dispatch('getPatient', data.id).then(() => {
                            const selected_patient = {
                                id: this.patient.id,
                                nom: this.patient.nom+" "+this.patient.prenoms,
                                nom_patient: this.patient.nom+" "+this.patient.prenoms,
                                prenoms: "",
                                sexe: this.patient.sexe.specificatif,
                                telephone_mobile: this.patient.telephone_mobile,
                                age: this.patient.age,
                                num_dossier: this.patient.code
                            }
                            this.$store.commit("SET_CHOSEN_PATIENT", selected_patient);

                            // Vente et demande de rendez-vous : le patient créé reste sur l'écran appelant.
                            if (this.type_enreg != 'vente' && this.type_enreg != 'rendez_vous') {
                                const action_selected = this.$store.getters["typeActionSelected"];
                                if (action_selected == "bon_consultation") {
                                    this.url_to_go = { name: 'Bon consultation' }
                                } else {
                                    this.url_to_go = { name: 'Bon medical' }
                                }
                                this.$router.push({
                                    name: this.url_to_go.name,
                                    params: {
                                        assurance_id: (this.assur_selected.id > 0) ? this.assur_selected.id : 0,
                                        societe_id: (this.societe_selected.id > 0) ? this.societe_selected.id : 0,
                                        taux: (this.new_patient.assur_taux_couverture),
                                        validite: this.new_patient.assur_validite
                                    }
                                })
                            }
                        })
                        // this.choosePatient(data)
                        

                        this.$store.dispatch('getPatient', data.id).then(() => {
                            const p_fullname = {
                                patient_nom: this.patient.nom + ' ' + this.patient.prenoms,
                                patient_id: this.patient.id,
                                patient_sexe: this.patient.sexe.specificatif,
                                patient_telephone: this.patient.telephone_mobile,
                                patient_age: this.patient.age,
                                num_dossier: this.patient.code
                            }
                            this.$emit('passNewPatient', p_fullname)
                        })
                        
                        this.doSuccessMsg();
                        this.oublierMembre();

                        (this.new_patient = {
                          country_suffix: this.default_country_code,
                          le_malade: "",
                          type_patient: "non_assure",
                          assur_selected: "",
                          societe_selected: "",
                          assur_validite: "",
                          assur_taux_couverture: "",
                          assur_principal_matricule: "",
                          assur_principal_nom: "",
                          assur_principal_prenom: "",
                          assur_principal_sexe: "",
                          assur_principal_phone: "",
                          malade_matricule: "",
                          malade_nom: "",
                          malade_prenom: "",
                          malade_sexe: "",
                          malade_age: "",
                          malade_phone: "",
                          malade_phone_secondaire: "",
                          malade_quartier: "",
                          malade_profession: "",
                          l_accompagnant: "",
                          accompagnant_nom: "",
                          accompagnant_prenom: "",
                          accompagnant_filiation: "",
                          accompagnant_phone: "",
                          accompagnant_quartier: "",
                          accompagnant_profession: "",
                          la_personne_a_prevenir: "",
                          personne_a_prevenir_nom: "",
                          personne_a_prevenir_prenom: "",
                          personne_a_prevenir_filiation: "",
                          personne_a_prevenir_phone: "",
                          personne_a_prevenir_quartier: "",
                          personne_a_prevenir_profession: "",
                        }),
                          this.$refs.add_patient.reset();
                        this.age_unit = 'ans';
                        this.second_phone_visible = false;
                        this.picked_choice = 'oui';
                        this.$refs.close_modal.click();
                    });
                }
                this.loading = false

            }).catch(error => {
                this.loading = false
                const data = error.response && error.response.data
                const errors = data && data.errors
                const messages = errors && (errors.date_naissance || errors.age_unit || errors.telephone_secondaire)
                this.doErrorMsg(messages && messages[0] || 'Impossible d’enregistrer le patient. Vérifiez les informations et réessayez.')
            })
        },

        doSuccessMsg: function () {
            this.$toasted.show('Le nouveau patient a été ajouté', {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'success'
            })
        },
        doErrorMsg: function (msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },
        dateFormatToSend: function (given_date) {
            let date = new Date(given_date)
            let month = date.getMonth() + 1,
                day = date.getDate();

            if (month < 10) month = '0' + month
            let date_to_send = `${date.getFullYear()}-${month}-${day}
                                      `;
            return { date: date, date_to_send: date_to_send }
        }

    }
}
